// ANCHOR Base
import { ChevronDown } from 'baseui/icon';
import { PanelOverrides } from 'baseui/accordion';

// ANCHOR Utils
import { THEME } from '@lyon/utils/theme';
import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';

export const PANEL: PanelOverrides<any> = {
  Header: {
    style: {
      borderBottomStyle: 'none',
      paddingTop: '16px',
      paddingBottom: '16px',
      backgroundColor: DARK_MUTED.darkmuted600,
      borderRadius: '4px',
    },
  },
  PanelContainer: {
    style: {
      borderBottomStyle: 'none',
      marginBottom: '12px',
    },
  },
  Content: {
    style: {
      marginTop: '-4px',
      backgroundColor: DARK_MUTED.darkmuted600,
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',

      [THEME.media.large]: {
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      [THEME.media.xlarge]: {
        paddingLeft: '48px',
        paddingRight: '64px',
      },
    },
  },
  ToggleIcon: {
    component: () => <ChevronDown size={32} />,
  },
};
